import React, { HTMLAttributes } from 'react';
import { styled } from '@mui/material';
import UploadIcon from '@/components/icons/Upload';
import Curtain from '@/components/Curtain';
import SupportedRevitVersions from './SupportedRevitVersions';
import t from '@/utils/translate';

const Text = styled('p')({
  margin: 0
});
const Text2 = styled(Text)({
  color: '#DFE1E6',
  textAlign: 'center'
});

export default (props: HTMLAttributes<HTMLDivElement>) => {
  return <Curtain {...props}>
    <UploadIcon style={{ width: '114px', height: '114px' }}/>
    <Text>{t('project.title.upload', true)}</Text>
    <Text2><SupportedRevitVersions /></Text2>
  </Curtain>;
};
